import { TAG_CATEGORIES } from 'src/constants/tag-categories'

export const DEFAULT_STATE = {
  selectedTagCategory: TAG_CATEGORIES.CAT_COMMUNICATIONS,
  selectedTagIds: [],
  selectedTagsContactsCount: 0
}
